import React from 'react';

/**
 * Branded text highlight utility.
 *
 * Syntax: wrap words or phrases with [hl]...[/hl] in any CMS text field.
 * Example: "Speak English with [hl]Confidence[/hl] — Wherever You Are"
 *
 * The highlighted portion renders with a brand-red underline accent
 * that works on any background color (white hero text or navy body text).
 *
 * Usage:
 *   import { parseHighlight } from '../utils/richText';
 *   <h1>{parseHighlight(heroTitle)}</h1>
 *
 * If the text contains no [hl] tokens the original string is returned
 * untouched — zero overhead for plain text.
 */

const HL_CLASS =
  'underline decoration-[#D72B2B] decoration-2 underline-offset-4';

export function parseHighlight(text) {
  if (!text || typeof text !== 'string' || !text.includes('[hl]')) return text;

  const parts = text.split(/(\[hl\].*?\[\/hl\])/gs);

  return parts.map((part, i) => {
    if (part.startsWith('[hl]') && part.endsWith('[/hl]')) {
      const inner = part.slice(4, part.length - 5);
      return (
        <span key={i} className={HL_CLASS}>
          {inner}
        </span>
      );
    }
    return part || null;
  });
}
